export default "__VITE_ASSET__C3NE$lDI__"